export const DEFAULT_LOCATION_STATS = {
    display: false,
    location: {},
    closestBinLocation: {lat: 0, lng: 0},
    rssi: 0,
    bitRate: 0,
    address: 0,
    distance: 0, // from the closest bin.
};
